<template>
	<div>
		<v-carousel
			:continuous="false"
			:show-arrows="false"
			hide-delimiters
			height="auto"
			light
			v-model="step"
		>
			<v-carousel-item>
				<template v-if="layers.length">
					<draggable
						v-model="layers"
						group="layers"
						@start="drag = true"
						@end="drag = false"
						v-bind="dragOptions"
						v-on:update="reorderLayers"
					>
						<transition-group
							type="transition"
							name="!drag ? 'flip-list' : null"
						>
							<template v-for="(layer) in layers">
								<MapLayer
									:layer="layer"
									class="mb-2"
									:key="layer.service.uniqueKey"
									:showSettings="setActiveLayer"
								/>
							</template>
						</transition-group>
					</draggable>
				</template>
				<template v-else>
					<div>Sluoksnių nėra</div>
				</template>
			</v-carousel-item>
			<v-carousel-item>
				<template v-if="activeLayer">
					<Back title="Grįžti į sluoksnių sąrašą" :action="showMainScreen" />
					<div class="mt-5">
						<MapLayerSettings
							:layer="activeLayer"
							:removeLayer="removeLayer"
							:key="activeLayer.service.uniqueKey"
							:myMap="myMap"
						/>
					</div>
				</template>
			</v-carousel-item>
		</v-carousel>
	</div>
</template>

<script>
	import MapLayer from "./components/MapLayer";
	import draggable from "vuedraggable";
	import Back from "../../../../../components/Back";
	import MapLayerSettings from "./components/MapLayerSettings";

	export default {
		data: function(){
			var data = {
				layers: [],
				dragOptions: {
					animation: 200,
					group: "features",
					disabled: false,
					ghostClass: "ghost"
				},
				drag: false,
				step: 0,
				activeLayer: null
			};
			return data;
		},
		props: {
			data: Object
		},
		components: {
			MapLayer,
			draggable,
			Back,
			MapLayerSettings
		},
		computed: {
			myMap: {
				get: function(){
					return this.data.myMap;
				}
			}
		},
		methods: {
			reorderLayers: function(){
				var length = this.layers.length;
				this.layers.forEach(function(layer, i){
					layer.setZIndex(length - i);
				}.bind(this));
			},
			setLayers: function(){
				this.layers = this.myMap.getLayers(true);
			},
			showMainScreen: function(){
				this.activeLayer = null;
			},
			setActiveLayer: function(layer){
				this.activeLayer = layer;
			},
			removeLayer: function(layer){
				this.myMap.map.removeLayer(layer);
				this.showMainScreen();
			}
		},
		created: function(){
			this.setLayers();
			this.myMap.map.getLayers().on("add", function(){
				this.setLayers();
			}.bind(this));
			this.myMap.map.getLayers().on("remove", function(){
				this.setLayers();
			}.bind(this));
		},
		watch: {
			activeLayer: {
				handler: function(newValue){
					if (newValue) {
						this.step = 1;
					} else {
						this.step = 0;
					}
				}
			}
		}
	};
</script>